import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getString } from '../resources/strings';
import { Class } from '../utils';
import QueryResult from '../QueryResult';
import { getWKTParser } from '../util/getWKTParser';
/**
 * Base class for all searchers
 * @class Searcher
 * @namespace Searcher
 * @constructs Searcher
 * @param {Object} options
 * @param [options.onSelect] {Searcher~selectCallback} Function to call when a result is selected by the user.
 * @param [options.searchDelay=0] {int} Delay in ms before executing the search
 * @param [options.matchesPhrase="matcher"] {string} Phrase used to display matches.
 * @param [options.usesGeoFunctions=false] {boolean} Does the implementation need the geo functions
 * @param [options.iconURI] {boolean} Does the implementation need the geo functions
 * @param [options.blankBehavior="search"] {string} "none"|"search"
 */
//noinspection JSCommentMatchesSignature

export default Class(
/** @lends Searcher# */
{
  //Private members
  //Dont touch
  _id: null,
  _onSelectCallback: null,
  detailHandlerDefs: null,
  customButtonDefs: null,
  onNewQueryHandlers: null,
  iconURI: null,
  _searchDelay: null,
  _sources: null,
  _matchesPhrase: null,
  allowDetails: false,
  toJSON: function toJSON() {
    return {
      id: this._id
    };
  },
  Searcher: function Searcher(options) {
    this.customButtonDefs = {
      "any": []
    };
    this.detailHandlerDefs = {
      "any": []
    }; //this.onNewQueryHandlers  = [];

    this._searchDelay = 0;
    this._sources = []; //[{source: this.CLASS_NAME, types: []}];

    this._matchesPhrase = getString("matches");

    this._onSelectCallback = function () {};

    this.blankBehavior = "search"; //none, search

    this.allowDetails = false;
    this.minimumShowCount = 0;

    if (options !== undefined) {
      if (typeof options.source !== 'undefined') this._sources = [{
        source: options.source,
        types: []
      }];
      if (typeof options.onSelect !== 'undefined') this._onSelectCallback = options.onSelect;
      if (options.matchesPhrase) this._matchesPhrase = options.matchesPhrase;
      this.minimumShowCount = 0;
      this.showMinimumOnBlank = false;
      if (typeof options.minimumShowCount !== 'undefined') if (options.minimumShowCount > 2) {
        this.minimumShowCount = options.minimumShowCount;
        if (options.showMinimumOnBlank) this.showMinimumOnBlank = true;
      }
      if (options.searchDelay) this._searchDelay = options.searchDelay;
      if (options.iconURI) this.iconURI = options.iconURI;
      if (options.blankBehavior) this.blankBehavior = options.blankBehavior;
      if (options.allowDetails) this.allowDetails = options.allowDetails;
      if (options.usesGeoFunctions) this.wktParser = getWKTParser();
    }

    this._id = this.CLASS_NAME + '_' + Math.floor(Math.random() * 999999999);
  },

  /**
   * A search result item created by a searcher
   * @typedef {Object} Searcher.Result
   * @property {string} title The title as displayed in the search result
   * @property {string} description The description as displayed in the search result
   * @property {object} geometry geojson
   * @property {Searcher} searcher
   * @property {object} data Searcher specific data - See each searcher for details
   */
  ready: function ready() {
    return Promise.resolve(true);
  },

  /**
   * @private
   */
  _fetchData: function _fetchData(query) {
    var _this = this;

    //Returns Promise. Calls caller if caller is set
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        _this.fetchData(query, {
          fetchSuccess: function fetchSuccess(queryResult) {
            resolve(queryResult);
          },
          fetchError: function fetchError(message) {
            reject(new Error(message));
          }
        });
      }, _this._searchDelay);
    });
  },

  /**
   * This method is called by the controller when the driver should fetch data. <br>
   * This method MUST be implemented by all searchers <br>
   * A call to this method MUST result in either a call to {@link Controller}.fetchSuccess({@link QueryResult}) or caller.fetchError()
   * @param {Controller} caller
   * */
  fetchData: function fetchData() {
    //Return error if fetchData hasn't been implemented in driver
    throw "Bad driver implementation in " + this.getId() + ". Method fetchData MUST be implemented";
  },

  /**
   * @private
   */
  _onSelect: function _onSelect(result) {
    return this.onSelect(result);
  },
  completeResult: function () {
    var _completeResult = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(result) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              result.isComplete = true;
              return _context.abrupt("return", result);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function completeResult(_x) {
      return _completeResult.apply(this, arguments);
    }

    return completeResult;
  }(),

  /**
   * This method is called by the controller when a result is selected. <br>
   * This method MAY be implemented by searchers. <br>
   * Implementations MUST call this._onSelectCallback(result)
   * @param {Searcher.Result} result
   */
  onSelect: function onSelect(result) {
    if (!result.isNewQuery()) this._onSelectCallback(result);
  },
  registerType: function registerType(sourceName, type) {
    //type: {id, singular, plural}
    var source = this.getSource(sourceName);

    if (typeof type === 'string' || type instanceof String) {
      //Ok only string is given - create object
      var typeObject = {
        id: type,
        singular: type,
        plural: type
      };
      source.types.push(typeObject);
    } else {
      if (typeof type.id === 'undefined') {
        throw this._id + ': Searcher.registerType() called with invalid type';
      } else {
        //Fix singular and plural if not given
        type.singular = type.singular ? type.singular : type.id;
        type.plural = type.plural ? type.plural : type.singular;
        source.types.push(type);
      }
    }
  },
  getSource: function getSource(sourceName) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this._sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _source = _step.value;
        if (_source.source.toLowerCase() === sourceName.toLowerCase()) return _source;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var source = {
      source: sourceName,
      types: []
    };

    this._sources.push(source);

    return source;
  },
  hasSource: function hasSource(sourceName) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = this._sources[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var source = _step2.value;
        if (source.source.toLowerCase() === sourceName.toLowerCase()) return true;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return false;
  },
  getSources: function getSources() {
    return this._sources;
  },
  hasType: function hasType(typeId) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this._sources[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var thisSource = _step3.value;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = thisSource.types[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var thisType = _step4.value;
            if (thisType.id.toLowerCase() === typeId.toLowerCase()) return true;
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return false;
  },
  hasTarget: function hasTarget(target) {
    if (target.source && target.type) return this.hasSource(target.source) && this.hasType(target.type);
  },
  getTypes_delete: function getTypes_delete() {
    return this._types;
  },

  /**
   * @private
   */
  getId: function getId() {
    return this._id;
  },

  /**
   * Create a {QueryResult}.
   * @returns {QueryResult}
   *
   */
  createQueryResult: function createQueryResult() {
    return new QueryResult(this);
  },

  /**
   * Convert a wkt string to a geojson object
   * @param {string} wkt
   * @returns {GeoJsonObject}
   */
  translateWktToGeoJsonObject: function translateWktToGeoJsonObject(wkt) {
    if (wkt === null) return null;
    return this.wktParser.parse(wkt);
  },
  translateGeoJsonObjectToWkt: function translateGeoJsonObjectToWkt(geoJsonObject) {
    return this.wktParser.convert(geoJsonObject);
  },
  get: function get() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      reject(new Error('Whoops! get(id) is not implemented in ' + _this2.CLASS_NAME));
    });
  },
  sq: function sq() {
    var _this3 = this;

    return new Promise(function (resolve) {
      resolve(_this3.createQueryResult());
    });
  },
  hasdetailHandlerDefs: function hasdetailHandlerDefs(result) {
    if (typeof result.detailHandlerDefs === 'undefined') result.detailHandlerDefs = this.getdetailHandlerDefs(result);
    return result.detailHandlerDefs.length > 0;
  },

  set detailhandlers(dhCollection) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = dhCollection[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var detailhandler = _step5.value;
        this.addDetailHandlerDef(detailhandler);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  },

  //This function may be overridden by implementations of search
  //Implementations may want to return this.customButtonDefs.any
  getdetailHandlerDefs: function getdetailHandlerDefs(result) {
    if (result.isNewQuery()) {
      return [];
    } else {
      var tentativeHandlerDefs = [];
      if (typeof result.type === 'undefined' || typeof this.detailHandlerDefs[result.type.toLowerCase()] === 'undefined') tentativeHandlerDefs = this.detailHandlerDefs.any;else tentativeHandlerDefs = this.detailHandlerDefs[result.type.toLowerCase()].concat(this.detailHandlerDefs.any);
      var handlerDefs = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = tentativeHandlerDefs[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var tentativeHandlerDef = _step6.value;
          if (typeof tentativeHandlerDef.isApplicable === 'undefined') handlerDefs.push(tentativeHandlerDef);else if (tentativeHandlerDef.isApplicable(result)) handlerDefs.push(tentativeHandlerDef);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return this.getDetailHandlersForResult(result).concat(handlerDefs);
    }
  },
  //This function may be overridden by implementations of search
  getDetailHandlersForResult: function getDetailHandlersForResult() {
    return [];
  },
  //This function may be overridden by implementations of search
  //Implementations may want to return this.customButtonDefs.any
  getCustomButtonDefs: function getCustomButtonDefs(result) {
    var buttonDefs = [];

    if (result.isNewQuery()) {
      return buttonDefs;
    } else {
      var tentativeButtonDefs = [];
      if (typeof result.type === 'undefined' || typeof this.customButtonDefs[result.type.toLowerCase()] === 'undefined') tentativeButtonDefs = this.getCustomButtonsForResult(result).concat(this.customButtonDefs.any);else tentativeButtonDefs = this.getCustomButtonsForResult(result).concat(this.customButtonDefs[result.type.toLowerCase()].concat(this.customButtonDefs.any));
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = tentativeButtonDefs[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var tentativeButtonDef = _step7.value;
          if (typeof tentativeButtonDef.isApplicable === 'undefined') buttonDefs.push(tentativeButtonDef);else if (tentativeButtonDef.isApplicable(result)) buttonDefs.push(tentativeButtonDef);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return buttonDefs;
    }
  },
  //This function may be overridden by implementations of search
  getCustomButtonsForResult: function getCustomButtonsForResult() {
    return [];
  },
  //{"buttonText": text, "buttonImage": imageUri, "handler": function(result, detailsContent)[, more: true|false]};
  //handler must return a thenable resolving to detail contents
  addDetailHandlerDef: function addDetailHandlerDef(detailHandlerDef, typeId) {
    if (typeof typeId === 'undefined') {
      this.detailHandlerDefs.any.push(detailHandlerDef);
    } else {
      var lowerType = typeId.toLowerCase();
      if (typeof this.detailHandlerDefs[lowerType] === 'undefined') this.detailHandlerDefs[lowerType] = [detailHandlerDef];else this.detailHandlerDefs[lowerType].push(detailHandlerDef);
    }
  },

  /**
   * Definition of a button, icon, or link which is presented together with search results
   * @typedef {Object} Searcher.CustomButtonDef
   * @property {string} buttonText Text or tooltip
   * @property {string} buttonImage URL of image (20*20)
   * @property {function} callBack Called when icon is clicked (callBack(result))
   * @property {string} [target] Name of target
   */

  /**
   * Displays an icon next to each result.
   * @param {Searcher.CustomButtonDef} customButtonDef
   * */
  addCustomButtonDef: function addCustomButtonDef(customButtonDef, typeId) {
    //fix the callback to make sure the result is completed before the callback is called
    var originalCallback = customButtonDef.callBack;

    customButtonDef.callBack =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(result) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = originalCallback;
                _context2.next = 3;
                return result.complete();

              case 3:
                _context2.t1 = _context2.sent;
                return _context2.abrupt("return", (0, _context2.t0)(_context2.t1));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }(); //Put in correct array of buttondefs (any or target)


    if (typeof typeId === 'undefined') {
      this.customButtonDefs.any.push(customButtonDef);
    } else {
      var lowerType = typeId.toLowerCase();
      if (typeof this.customButtonDefs[lowerType] === 'undefined') this.customButtonDefs[lowerType] = [customButtonDef];else this.customButtonDefs[lowerType].push(customButtonDef);
    }
  },
  CLASS_NAME: 'Septima.Search.Searcher'
});